export default "__VITE_ASSET__gFyQY6ec__"